import { network } from '@tencent/netcheck';

export class Util {
    public static instance: Util;
    public static getInstance() {
        if (!Util.instance) {
            Util.instance = new Util();
        }
        return Util.instance;
    }

    public async getCookie(key: string): Promise<string> {
        const r = new RegExp(`(?:^|;+|\\s+)${key}=([^;]*)`);
        let m: string[] | null = null;
        if (document) {
            m = document.cookie.match(r);
        }
        return (!m ? '' : m[1]) ?? '';
    }

    public async getXSRF(): Promise<string> {
        return this.getCookie('TOK');
    }

    public async isOnline(): Promise<boolean> {
        return network.isOnline;
    }
}
